const initialState = {
  fetching: [],
  saving: []
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCHING_DATA_STATE':
      var newState = [...state.fetching];
      if(action.state){
        newState.push(1);
      }
      else{
        newState.pop();
      }
      return {
        ...state,
        fetching: newState
      };
    case 'SAVING_DATA_STATE':
      newState = [...state.saving];
      if(action.state){
        newState.push(1);
      }
      else{
        newState.pop();
      }
      return {
        ...state,
        saving: newState
      };
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/dataState.js